<div class="create-request-dialog" role="dialog" aria-modal="true" aria-labelledby="dialog-title">
    <button class="back-button" (click)="goBack()" *ngIf="currentStep !== STEP_REQUEST_SENT && currentStep !== STEP_CHOOSE_CITIZEN" aria-label="Go back">
        <i class="icon-caret-left"></i>
    </button>
    <button class="close-dialog-button" (click)="closeDialog()">
        <i class="icon-close"></i>
    </button>

    <div class="dialog-header">
        <h1 class="dialog-header-text">{{ 'request_v2.create-request-dialog.title' | translate }}</h1>
    </div>

    <div class="stepper-container" *ngIf="currentStep !== STEP_REQUEST_SENT">
        <ul class="stepper">
            <li
                class="step"
                [ngClass]="{
                    completed: STEP_CHOOSE_CITIZEN < currentStep,
                    active: STEP_CHOOSE_CITIZEN === currentStep,
                    clickable: STEP_CHOOSE_CITIZEN < currentStep
                }"
                (click)="goToStep(STEP_CHOOSE_CITIZEN)"
            >
                <span class="step-circle">
                    <i *ngIf="STEP_CHOOSE_CITIZEN < currentStep" class="icon-check"></i>
                    <span *ngIf="STEP_CHOOSE_CITIZEN === currentStep" class="active-dot"></span>
                </span>
                <span class="step-label">{{ 'request_v2.create-request-dialog.stepper.choose-citizen' | translate }}</span>
            </li>
            <li
                class="step"
                [ngClass]="{
                    completed: STEP_CATEGORY < currentStep,
                    active: STEP_CATEGORY === currentStep,
                    clickable: STEP_CATEGORY < currentStep
                }"
                (click)="goToStep(STEP_CATEGORY)"
            >
                <span class="step-circle">
                    <i *ngIf="STEP_CATEGORY < currentStep" class="icon-check"></i>
                    <span *ngIf="STEP_CATEGORY === currentStep" class="active-dot"></span>
                </span>
                <span class="step-label">{{ 'request_v2.create-request-dialog.stepper.category' | translate }}</span>
            </li>
            <li
                class="step"
                [ngClass]="{
                    completed: STEP_SUBCATEGORY < currentStep,
                    active: STEP_SUBCATEGORY === currentStep,
                    clickable: STEP_SUBCATEGORY < currentStep
                }"
                (click)="goToStep(STEP_SUBCATEGORY)"
            >
                <span class="step-circle">
                    <i *ngIf="STEP_SUBCATEGORY < currentStep" class="icon-check"></i>
                    <span *ngIf="STEP_SUBCATEGORY === currentStep" class="active-dot"></span>
                </span>
                <span class="step-label">{{ 'request_v2.create-request-dialog.stepper.subcategory' | translate }}</span>
            </li>
            <li
                class="step"
                [ngClass]="{
                    completed: STEP_LOCATION < currentStep,
                    active: STEP_LOCATION === currentStep,
                    clickable: STEP_LOCATION < currentStep
                }"
                (click)="goToStep(STEP_LOCATION)"
            >
                <span class="step-circle">
                    <i *ngIf="STEP_LOCATION < currentStep" class="icon-check"></i>
                    <span *ngIf="STEP_LOCATION === currentStep" class="active-dot"></span>
                </span>
                <span class="step-label">{{ 'request_v2.create-request-dialog.stepper.location' | translate }}</span>
            </li>
            <li
                class="step"
                [ngClass]="{
                    completed: STEP_REQUEST_INFO < currentStep && currentStep !== STEP_VALIDATION,
                    active: STEP_REQUEST_INFO === currentStep || currentStep === STEP_VALIDATION
                }"
            >
                <span class="step-circle">
                    <i *ngIf="STEP_REQUEST_INFO < currentStep && currentStep !== STEP_VALIDATION" class="icon-check"></i>
                    <span *ngIf="STEP_REQUEST_INFO === currentStep || currentStep === STEP_VALIDATION" class="active-dot"></span>
                </span>
                <span class="step-label">{{ 'request_v2.create-request-dialog.stepper.details' | translate }}</span>
            </li>
        </ul>
    </div>
    <div class="linking-flow-message" *ngIf="currentStep !== STEP_REQUEST_SENT && openedFromLinkingFlow">
        {{ 'request_v2.create-request-dialog.linking-flow-helper' | translate: { requestId: preLinkedSourceRequestId } }}
    </div>

    <div class="dialog-content">

        <div *ngIf="currentStep === STEP_CHOOSE_CITIZEN" class="choose-citizen-step">
            <div class="step-header" *ngIf="!isCreatingCitizen">
                <h2 class="step-title">{{ 'request_v2.create-request-dialog.select-requester' | translate }}</h2>
                <p class="step-description">{{ 'request_v2.create-request-dialog.search-citizen-helper' | translate }}</p>
            </div>
            <div class="step-header" *ngIf="isCreatingCitizen">
                <h2 class="step-title">{{ 'request_v2.create-request-dialog.register-new-citizen' | translate }}</h2>
                <p class="step-description">{{ 'request_v2.create-request-dialog.register-citizen-helper' | translate }}</p>
            </div>

            <div class="search-section" *ngIf="!isCreatingCitizen">
                <div class="current-user-section" *ngIf="currentUser" (click)="selectCurrentUser()">
                    <div class="user-card hoverable" [class.selected]="isCurrentUserSelected()">
                        <div class="user-avatar">
                            <img *ngIf="currentUser.picture" [src]="currentUser.picture" alt="User Avatar">
                            <div *ngIf="!currentUser.picture" class="default-avatar">
                                <i class="icon-user"></i>
                            </div>
                        </div>
                        <div class="user-details">
                            <div class="user-name">
                                {{ currentUser.firstName }} {{ currentUser.lastName }}
                                <span class="me-badge">{{ 'request_v2.create-request-dialog.me' | translate }}</span>
                            </div>
                            <div class="user-email">{{ currentUser.email }}</div>
                            <div class="user-phone" *ngIf="currentUser.phone">{{ currentUser.phone }}</div>
                        </div>
                    </div>
                </div>

                <div class="divider-text" *ngIf="currentUser">
                    <span>{{ 'request_v2.create-request-dialog.or-search' | translate }}</span>
                </div>

                <app-search-dropdown
                    [mode]="'single'"
                    [selectedUsers]="[]"
                    (usersSelected)="onCitizenSelected($event)"
                    [placeholder]="'access_control.dialog.search_user' | translate"
                    [showCreateOption]="true"
                    [showRadio]="false"
                    (createOptionClicked)="onCitizenCreateClick($event)"
                ></app-search-dropdown>

                <div class="selected-user-summary" *ngIf="selectedCitizen && !isCurrentUserSelected()">
                    <div class="user-card selected">
                        <div class="user-avatar">
                            <img *ngIf="selectedCitizen.picture" [src]="selectedCitizen.picture" alt="User Avatar">
                            <div *ngIf="!selectedCitizen.picture" class="default-avatar">
                                <i class="icon-user"></i>
                            </div>
                        </div>
                        <div class="user-details">
                            <div class="user-name">
                                {{ selectedCitizen.firstName || selectedCitizen.name }} {{ selectedCitizen.lastName }}
                            </div>
                            <div class="user-email">{{ selectedCitizen.email }}</div>
                            <div class="user-phone" *ngIf="selectedCitizen.phone">{{ selectedCitizen.phone }}</div>
                        </div>
                        <button class="remove-user-btn" (click)="selectedCitizen = null">
                            <i class="icon-close"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="create-citizen-section" *ngIf="isCreatingCitizen">
                <form [formGroup]="newCitizenForm" (ngSubmit)="submitNewCitizen()" class="citizen-form">
                    <div class="form-row">
                        <div class="form-group half-width">
                            <label>{{ 'request_v2.create-request-dialog.first-name' | translate }} *</label>
                            <input type="text" formControlName="firstName" [placeholder]="'request_v2.create-request-dialog.first-name-placeholder' | translate">
                            <div class="error-message" *ngIf="newCitizenForm.get('firstName').touched && newCitizenForm.get('firstName').invalid">
                                {{ 'request_v2.create-request-dialog.errors.required' | translate }}
                            </div>
                        </div>
                        <div class="form-group half-width">
                            <label>{{ 'request_v2.create-request-dialog.last-name' | translate }} *</label>
                            <input type="text" formControlName="lastName" [placeholder]="'request_v2.create-request-dialog.last-name-placeholder' | translate">
                            <div class="error-message" *ngIf="newCitizenForm.get('lastName').touched && newCitizenForm.get('lastName').invalid">
                                {{ 'request_v2.create-request-dialog.errors.required' | translate }}
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>{{ 'request_v2.create-request-dialog.email' | translate }} *</label>
                        <input type="email" formControlName="email" [placeholder]="'request_v2.create-request-dialog.email-placeholder' | translate">
                        <div class="error-message" *ngIf="newCitizenForm.get('email').touched && newCitizenForm.get('email').hasError('required')">
                            {{ 'request_v2.create-request-dialog.errors.required' | translate }}
                        </div>
                        <div class="error-message" *ngIf="newCitizenForm.get('email').touched && newCitizenForm.get('email').hasError('pattern') && !newCitizenForm.get('email').hasError('required')">
                            {{ 'request_v2.create-request-dialog.errors.email' | translate }}
                        </div>
                    </div>

                    <div class="form-group">
                        <label>{{ 'request_v2.create-request-dialog.phone' | translate }}</label>
                        <input type="tel" formControlName="phone" appPhoneMask [placeholder]="'request_v2.create-request-dialog.phone-placeholder' | translate">
                        <div class="error-message" *ngIf="newCitizenForm.get('phone').touched && (newCitizenForm.get('phone').hasError('minlength') || newCitizenForm.get('phone').hasError('maxlength'))">
                            {{ 'request_v2.create-request-dialog.errors.phone-invalid' | translate }}
                        </div>
                    </div>

                    <div class="citizen-form-actions">
                        <a class="back-link" (click)="cancelCitizenCreation()">{{ 'request_v2.create-request-dialog.back-to-search' | translate }}</a>
                        <button type="submit" class="submit-citizen-btn" [disabled]="creatingCitizen">
                            <mat-spinner *ngIf="creatingCitizen" diameter="20"></mat-spinner>
                            <span *ngIf="!creatingCitizen">{{ 'request_v2.create-request-dialog.register-citizen-button' | translate }}</span>
                        </button>
                    </div>
                </form>
            </div>


        </div>

        <app-category-selection
            *ngIf="currentStep === STEP_CATEGORY"
            [categories]="categories"
            [loading]="loading"
            [selectedCategory]="selectedCategory"
            (categorySelected)="onCategorySelected($event)"
        ></app-category-selection>

        <app-skeleton-loader *ngIf="currentStep === STEP_SUBCATEGORY && loading"></app-skeleton-loader>
        <app-subcategory-selection
            *ngIf="currentStep === STEP_SUBCATEGORY"
            [selectedCategory]="selectedCategory"
            [selectedSubcategory]="selectedSubcategory"
            (subcategorySelected)="onSubcategorySelected($event)"
        ></app-subcategory-selection>

        <app-skeleton-loader *ngIf="currentStep === STEP_LOCATION && loading"></app-skeleton-loader>
        <app-location-selection
            *ngIf="currentStep === STEP_LOCATION"
            #locationComponent
            [selectedCategory]="selectedCategory"
            [selectedSubcategory]="selectedSubcategory"
            [previouslySelectedLocation]="selectedLocation"
            (locationSelected)="onLocationSelected($event)"
            (locationRequestData)="onLocationRequestDataChange($event)"
            (skipLocation)="skipLocation()"
            (selectionStateChanged)="onLocationSelectionChanged($event)"
        ></app-location-selection>

        <app-request-information
            *ngIf="currentStep === STEP_REQUEST_INFO"
            #requestInfoComponent
            [selectedCategory]="selectedCategory"
            [selectedSubcategory]="selectedSubcategory"
            [initialDescription]="requestDescription"
            [initialFiles]="requestFiles"
            [initialLinks]="requestLinks"
            (requestInfoSubmitted)="onRequestInfoSubmitted($event)"
            (nextStep)="onStepChange(STEP_VALIDATION)"
        ></app-request-information>

        <app-skeleton-loader *ngIf="currentStep === STEP_VALIDATION && submitting"></app-skeleton-loader>
        <app-validate-information
            *ngIf="currentStep === STEP_VALIDATION && !submitting"
            [selectedCategory]="selectedCategory"
            [selectedSubcategory]="selectedSubcategory"
            [location]="selectedLocation"
            [requestDescription]="requestDescription"
            [attachedFiles]="attachedFiles"
            [requestLinks]="requestLinks"
            [isPublicRequest]="isPublicRequest"
            (requestValidated)="onRequestValidated($event)"
            (publicStatusChanged)="onPublicStatusChanged($event)"
        ></app-validate-information>

        <app-request-sent
            *ngIf="currentStep === STEP_REQUEST_SENT"
            [requestCategory]="selectedCategory?.name??''"
            [requestSubcategory]="selectedSubcategory?.name??''"
            [requestId]="createdRequestId??''"
            (close)="closeRequestSent()"
        ></app-request-sent>
    </div>

    <!-- Desktop actions -->
    <div class="dialog-actions" [ngClass]="{ 'dual-actions': currentStep === STEP_LOCATION || currentStep === STEP_VALIDATION }" *ngIf=" ![STEP_CATEGORY, STEP_SUBCATEGORY, STEP_REQUEST_SENT].includes(currentStep)">
        <button
            *ngIf="[STEP_CHOOSE_CITIZEN, STEP_LOCATION, STEP_REQUEST_INFO].includes(currentStep)"
            class="next-button"
            [ngClass]="{ 'next-button-with-alt': currentStep === STEP_LOCATION }"
            [disabled]="!canProceed()"
            (click)="next()"
        >
            {{ 'request_v2.create-request-dialog.next-button' | translate }}
        </button>
        <button *ngIf="currentStep === STEP_VALIDATION" class="create-button" (click)="createOnly()" [disabled]="submitting">
                  <mat-spinner *ngIf="submitting" diameter="20"></mat-spinner>
                {{ 'request_v2.create-request-dialog.create-button' | translate }}
        </button>
    </div>

   
</div>
